export const apiURL = process.env.NODE_ENV !== 'production' ? 'http://localhost:8080/api' : 'https://thtserver.herokuapp.com/api'
//http://localhost:3030/api
export const LOCAL_STORAGE_TOKEN_NAME = 'dlm-admin'

export const SET_AUTH = 'SET_AUTH'

export const TASK_LOADED_SUCCESS = 'TASK_LOADED_SUCCESS'

export const TASK_LOADED_FAIL = 'TASK_LOADED_FAIL'

export const UPDATE_TASK = 'UPDATE_TASK'

export const FIND_TASK = 'FIND_TASK'

export const DELETE_TASK = 'DELETE_TASK'

export const ADD_TASK = 'ADD_TASK'

export const THEMATIC_LOADED_SUCCESS = 'THEMATIC_LOADED_SUCCESS'

export const THEMATIC_LOADED_FAIL = 'THEMATIC_LOADED_FAIL'

export const UPDATE_THEMATIC = 'UPDATE_THEMATIC'

export const FIND_THEMATIC = 'FIND_THEMATIC'

export const DELETE_THEMATIC = 'DELETE_THEMATIC'

export const ADD_THEMATIC = 'ADD_THEMATIC'

export const LESSON_LOADED_SUCCESS = 'LESSON_LOADED_SUCCESS'

export const LESSON_LOADED_FAIL = 'LESSON_LOADED_FAIL'

export const UPDATE_LESSON = 'UPDATE_LESSON'

export const FIND_LESSON = 'FIND_LESSON'

export const DELETE_LESSON = 'DELETE_LESSON'

export const ADD_LESSON = 'ADD_LESSON'

export const USER_LOADED_SUCCESS = 'USER_LOADED_SUCCESS'

export const USER_LOADED_FAIL = 'USER_LOADED_FAIL'

export const UPDATE_USER = 'UPDATE_USER'

export const FIND_USER = 'FIND_USER'

export const DELETE_USER = 'DELETE_USER'

export const QUESTION_LOADED_SUCCESS = 'QUESTION_LOADED_SUCCESS'

export const QUESTION_LOADED_FAIL = 'QUESTION_LOADED_FAIL'

export const UPDATE_QUESTION = 'UPDATE_QUESTION'

export const FIND_QUESTION = 'FIND_QUESTION'

export const DELETE_QUESTION = 'DELETE_QUESTION'

export const ADD_QUESTION = 'ADD_QUESTION'

export const CONTEST_LOADED_SUCCESS = 'CONTEST_LOADED_SUCCESS'

export const CONTEST_LOADED_FAIL = 'CONTEST_LOADED_FAIL'

export const UPDATE_CONTEST = 'UPDATE_CONTEST'

export const FIND_CONTEST = 'FIND_CONTEST'

export const DELETE_CONTEST = 'DELETE_CONTEST'

export const ADD_CONTEST = 'ADD_CONTEST'

export const TEXT_LOADED_SUCCESS = 'TEXT_LOADED_SUCCESS'

export const TEXT_LOADED_FAIL = 'TEXT_LOADED_FAIL'

export const UPDATE_TEXT = 'UPDATE_TEXT'

export const FIND_TEXT = 'FIND_TEXT'

export const DELETE_TEXT = 'DELETE_TEXT'

export const ADD_TEXT = 'ADD_TEXT'